export const checksums = {
  "checks": "v3.5.0--5WopJ30cy3I-yu0_QORDVHwz68bDZeClccfBTzU36fM"
}
export const checksumsStructure = {
  "checks": "gWThLZZmn5cB5xClA7n_Sz80g496W5Vpe59f5hgAprE"
}

export const tables = {
  "checks": "_content_checks",
  "info": "_content_info"
}

export default {
  "checks": {
    "type": "page",
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json",
      "path": "string",
      "title": "string",
      "description": "string",
      "seo": "json",
      "body": "json",
      "navigation": "json",
      "points": "json",
      "businessCategories": "json",
      "channelCategory": "string"
    }
  },
  "info": {
    "type": "data",
    "fields": {}
  }
}